import React, { memo } from "react";
import { formatDate } from "../../helper/Helper";

function CouponList({ item, isApplied, onApply }) {
  const { title, code, endDate } = item;

  return (
    <div className="coupon-card">
      <h3>{title}</h3>
      <div className="coupon-row">
        <span id="cpnCode">{code}</span>
        <span
          id="cpnBtn"
          className={`coupon-btn ${isApplied ? "applied" : ""}`}
          onClick={onApply}
          disabled={isApplied}
        >
          {isApplied ? "Applied" : "Apply"}
        </span>
      </div>
      <p>Valid Till: {formatDate(endDate)}</p>
      <div className="circle1" />
      <div className="circle2" />
    </div>
  );
}

export default memo(CouponList);
